module.exports = __webpack_public_path__ + "img/contract_top2.849f9098.png";